module.exports = __webpack_public_path__ + "static/media/jama_hari.6f6b30d7.png";